import React from 'react';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import { TextLink, Layout, Divider } from '@oneaudi/unified-web-components';
import type { City } from '../../../models/common/places';

export type Props = {
  places: City[];

  query: string;
  selectedPosition?: number;

  onPlaceClick: (city: City, pos: number) => void;
};

export const PlacesList = ({ onPlaceClick, places, selectedPosition }: Props) => {
  const handlePlaceSelect = (p: City, index: number) => {
    const pos = index + 1;
    onPlaceClick(p, pos);
  };

  return (
    <Layout
      direction="column"
      // margin={['24px', '28px', '24px', '28px']}
      data-test-id="places-list-component"
    >
      <List role="list">
        {places.map((place, index) => (
          <PlaceContainer
            key={place.placeId}
            role="listitem"
            tabIndex={-1}
            data-test-id="place-container"
          >
            <Place
              aria-label={`select ${place.name}, ${place.countryName}`}
              aria-selected={index === selectedPosition}
              icon="poi"
              iconPosition="leading"
              onClick={() => {
                handlePlaceSelect(place, index);
              }}
              data-test-id="place"
              variant="standalone"
              size="md"
              margin={[SYS_SPACE_FIXED_200, 0]}
            >
              {`${place.name},`}
              <br />
              {place.countryName}
            </Place>
            <Divider />
          </PlaceContainer>
        ))}
      </List>
    </Layout>
  );
};

const PlaceContainer = styled.div``;

const Place = styled(TextLink)`
  text-align: left;
  text-decoration: none;
  min-height: auto;
  width: fit-content;
`;
const List = styled.ul`
  list-style: none;
  padding: 0;
`;
